import { render } from "./AcceptablePolicy.vue?vue&type=template&id=933e0dd8"
import script from "./AcceptablePolicy.vue?vue&type=script&lang=js"
export * from "./AcceptablePolicy.vue?vue&type=script&lang=js"
script.render = render

export default script